import axios from 'axios';
import Nprogress from 'nprogress';
import { authStore } from '@/store/store';
import CryptoJS from 'crypto-js';
import router from '@/router';

function _clientResponseHandler(obj) {
  const objString = CryptoJS.AES.decrypt(obj?.data.packet, process.env.VUE_APP_COMMUNICATION_KEY).toString(CryptoJS.enc.Utf8);
  obj.data = JSON.parse(objString)
  return obj
}

function _clientRequestHandler(req){
  const keys = ['query','params','body','data']
  keys.forEach(key => {
    if(req[key]){
      req[key] = {packet:CryptoJS.AES.encrypt(JSON.stringify(req[key]), process.env.VUE_APP_COMMUNICATION_KEY).toString()};  
    }
  })
  return req;
}

const client = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: { Accept: 'application/json' }
})

client.interceptors.request.use(req => {
  const user = authStore().decryptAuth?.profile
  if (user?.token) req.headers['XAuth'] = user.token
  req = _clientRequestHandler(req)
  Nprogress.start()
  return req
})

client.interceptors.response.use(response => {
  Nprogress.done()
  return _clientResponseHandler(response)
}, error => {
    Nprogress.done()
    //@Todo: we should possibly use a different status code
    let _err = _clientResponseHandler(error?.response)
    if(_err.data.type == "not_authenticated") {
      _err.data.message = "You've been logged out, kindly login again."
      authStore().logOut()
      router.push('/')
    }
    
    return Promise.reject(_err)
})

export default client
